import { createFileRoute, Outlet } from '@tanstack/react-router';

import { AppProviders } from '@/app/providers/AppProviders';

export const Route = createFileRoute('/admin')({
  component: () => (
    <AppProviders>
      <Outlet />
    </AppProviders>
  ),
});
